import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-0 mb-0" }, {
      default: _withCtx(() => [
        (_ctx.mailTemplates?.length > 1)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12",
              lg: "6",
              xl: "7",
              class: "pt-0 pb-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select_filled, {
                  persistent: "",
                  label: "Modèle de mail",
                  modelValue: _ctx.selectedTemplateName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplateName) = $event)),
                  items: _ctx.mailTemplates,
                  "item-title": "title",
                  class: "pb-4",
                  "data-cy": "InvoiceMailTemplatesSetting-mailTemplate",
                  ref: "mailTemplateSelect"
                }, {
                  item: _withCtx(({ item }) => [
                    _createVNode(_component_v_list_item, {
                      onClick: ($event: any) => (_ctx.onTemplateChange(item.value))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          align: "center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              "data-cy": "InvoiceMailTemplatesSetting-template",
                              cols: "8"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(item.title), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "4",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                (item.value !== _ctx.DEFAULT_TEMPLATE_NAME)
                                  ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                      key: 0,
                                      "data-cy": "InvoiceMailTemplatesSetting-delete",
                                      color: "red",
                                      "x-small": "",
                                      onClick: _withModifiers(($event: any) => (_ctx.openDeleteMailTemplateDialog(item?.value)), ["stop"])
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "items"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_col, {
          cols: "12",
          lg: "6",
          xl: "5",
          class: "pt-0 pb-4 d-flex align-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_primary, {
              block: "",
              size: "default",
              onClick: _ctx.showAddTemplateModal,
              "data-cy": "InvoiceMailTemplatesSetting-addNewMailTemplateBtn"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Ajouter un nouveau modèle ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      title: "Suppression du modèle de mail",
      width: "550px",
      onValid: _ctx.confirmDeleteTemplate,
      onClose: _ctx.closeDeleteMailTemplateDialog
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir supprimer ce modèle de mail ? Cette action est irréversible ", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "onClose"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialog) = $event)),
      minWidth: "30vw",
      title: "Ajouter un nouveau modèle",
      onClose: _ctx.closeAddTemplateModal,
      onValid: _ctx.addNewMailTemplate,
      prefixDataCy: "InvoiceMailTemplatesSetting-addNewTempateModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field_filled, {
          "data-cy": "InvoiceMailTemplatesSetting-newTemplateName",
          label: "Nom du modèle",
          modelValue: _ctx.templateTitle,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.templateTitle) = $event)),
          required: "",
          "error-messages": _ctx.errorMessage
        }, null, 8, ["modelValue", "error-messages"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "onValid"])
  ], 64))
}